import React, { useEffect, useRef } from 'react';

const GameLog = ({ logs }) => {
  const logEndRef = useRef(null);

  // Auto-scroll to bottom when new logs arrive
  useEffect(() => {
    logEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [logs]);

  if (!logs || logs.length === 0) return null;

  return (
    <div 
      className="w-36 sm:w-48 max-h-36 overflow-y-auto rounded-lg shadow-lg pointer-events-none"
      style={{
        background: 'rgba(13, 31, 20, 0.35)',
        backdropFilter: 'blur(6px)',
        border: '1px solid rgba(212, 168, 67, 0.15)',
        WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
        maskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
        scrollbarWidth: 'none', // Firefox
        msOverflowStyle: 'none',  // IE/Edge
      }}
    >
      <div className="p-2 flex flex-col gap-1.5 relative">
        {logs.map((log) => (
          <div 
            key={log.id} 
            className="animate-slide-in leading-snug flex items-start"
            style={{
              color: log.type === 'IMPORTANT' ? '#d4a843' : 'rgba(245,234,210,0.82)',
              fontFamily: log.type === 'IMPORTANT'
                ? '"Cinzel", Georgia, serif'
                : '"IM Fell English SC", Georgia, serif',
              fontSize: log.type === 'IMPORTANT' ? '0.68rem' : '0.63rem',
              fontWeight: log.type === 'IMPORTANT' ? '700' : '400',
              letterSpacing: log.type === 'IMPORTANT' ? '0.06em' : '0.02em',
              textShadow: log.type === 'IMPORTANT' ? '0 0 8px rgba(212,168,67,0.5)' : 'none',
            }}
          >
            {log.icon && <span className="mr-1 mt-0.5">{log.icon}</span>}
            <span style={{ wordBreak: 'break-word' }}>{log.text}</span>
          </div>
        ))}
        <div ref={logEndRef} />
      </div>

      <style jsx>{`
        /* Hide scrollbar for Chrome, Safari and Opera */
        div::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default GameLog;
